<template>
  <div>
    <FormulateForm
      name="login"
      v-model="formValues"
      @submit="login"
      class="mb-6"
    >
      <h1 class="font-bold text-3xl mb-8">
        Login
      </h1>

      <FormulateInput
        name="email"
        type="email"
        label="Email address"
        placeholder="Email address"
        validation="bail|required|email"
      />
      <FormulateInput
        name="password"
        type="password"
        label="Password"
        placeholder="Your password"
        validation="bail|required|min:8,length"
        validation-name="Password"
      />
      <FormulateErrors />
      <base-button type="submit" :loading="sending">
        Log in
      </base-button>
    </FormulateForm>

    <router-link
      to="/forgot-password"
      class="inline-block mr-4 text-sm text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Forgot password?
    </router-link>
    <router-link
      to="/signup"
      class="inline-block text-sm text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Create a new account
    </router-link>
  </div>
</template>

<script>
const devValues =
  process.env.NODE_ENV === 'production'
    ? {}
    : {
        email: 'marek.pietrzak@feld-m.de',
        password: 'test12!@',
      };

export default {
  data() {
    return {
      sending: false,
      formValues: devValues,
    };
  },
  methods: {
    async login(data) {
      try {
        this.sending = true;
        const {
          data: { key },
        } = await this.$api.post('rest-auth/login/', data);
        await this.$store.dispatch('auth/login', key);
        this.$router.push(this.$route.query.redirect || '/');
      } catch (error) {
        this.$formulate.handle(error, 'login');
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
